import {useTranslation} from 'react-i18next';
import {isRouteErrorResponse, useRouteError} from 'react-router-dom';

import BlankLayout from '../layouts/BlankLayout';
import ErrorMessageTemplate from '../templates/ErrorMessageTemplate';

function RootErrorElement() {
  const {t} = useTranslation();
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <BlankLayout>
        <ErrorMessageTemplate
          className="min-h-[50vh]"
          title={`${error.status}`}
          subtitle={error.statusText}
        >
          {(error.data as {message?: string})?.message}
        </ErrorMessageTemplate>
      </BlankLayout>
    );
  }

  if (error instanceof Error) {
    return (
      <BlankLayout>
        <ErrorMessageTemplate
          className="min-h-[50vh]"
          title={t('Unhandled error')}
        >
          {error.message}
        </ErrorMessageTemplate>
      </BlankLayout>
    );
  }

  return (
    <BlankLayout>
      <ErrorMessageTemplate
        className="min-h-[50vh]"
        title={t('Unknown error')}
      />
    </BlankLayout>
  );
}
export default RootErrorElement;
